import { Controller } from "stimulus"

export default class extends Controller {

  reload() {
    setTimeout(function() {
      location.reload()
    }, 3000);
  }
}
